import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {PriceRobotProductsService} from '../services/price-robot-products.service';
import {PriceRobotProduct} from '../services/price-robot-product';
import {ChartConfiguration, ChartOptions} from 'chart.js';
import {PriceRobotMessageService} from '../services/price-robot-message.service';
import {HttpClient} from '@angular/common/http';
import {PriceRobotCrawlerUrlService} from '../services/price-robot-crawler-url.service';
import {ProductsService} from '@hassel-it/shop-services';
import {User, UsersService} from '@hassel-it/angular-common';
import {PriceRobotCompetitorService} from '../services/price-robot-competitor.service';
import {PriceRobotUrl} from '../services/price-robot-url';
import {PriceRobotCompetitor} from '../services/price-robot-competitor';
import {PriceRobotRulesService} from '../services/price-robot-rules.service';
import {PriceRobotRule} from '../services/price-robot-rule';
import {forkJoin} from "rxjs";
import {environment} from "../../environments/environment";

@Component({
    providers: [ProductsService],
    selector: 'app-price-robot-product',
    templateUrl: './price-robot-product.component.html',
    styleUrls: ['./price-robot-product.component.scss']
})
export class PriceRobotProductComponent implements OnInit {
    public modal: NgbModalRef;
    public param: any;
    public product: PriceRobotProduct = null;
    public priceRobotUrl: PriceRobotUrl = null;
    public loading = false;
    public prices: number[] = [];
    public competitors: PriceRobotCompetitor[] = [];
    public crawler_urls = [];
    public labels: String[] = [];
    public lineChartData: ChartConfiguration['data'] = {
        datasets: [],
        labels: []
    };
    public favorite: any;
    public users: User[] = [];
    public rules: PriceRobotRule[] = [];
    includeShipping: any;

    constructor(
        private shopProductsService: ProductsService,
        private priceRobotProductsApiService: PriceRobotProductsService,
        private priceRobotMessageService: PriceRobotMessageService,
        private priceRobotCrawlerUrlService: PriceRobotCrawlerUrlService,
        private priceRobotCompetitorService: PriceRobotCompetitorService,
        private priceRobotRulesService: PriceRobotRulesService,
        private route: ActivatedRoute,
        private modalService: NgbModal,
        public usersService: UsersService,
        public http: HttpClient) {
    }

    ngOnInit(): void {

        forkJoin([
            this.usersService.getUsers({all: true}),
            // <Observable<PriceRobotCompetitor[]>>
            this.priceRobotCompetitorService.index()]
        ).subscribe(
            data => {
                this.users = data[0].results;
                this.competitors = data[1].competitors;
            }
        );

        this.route.paramMap.subscribe(params => {
            this.param = params.get('productId');
            this.loadData();
        })
    }

    loadData() {

        this.priceRobotRulesService.index({forProductId: this.param}).subscribe(response => {
            const data: any = response;
            this.rules = data.rules;
        });

        this.priceRobotProductsApiService.view(this.param).subscribe(result => {
            this.product = result;
            const favoritStatus = this.product.variants.find((item) => {
                return item.variant_group_id === 2 // @todo favorit gruppe id ?
            });
            this.favorite = !!favoritStatus;
            this.loading = false;
            this.configureData(30);
        }, error => {
            this.priceRobotMessageService.handleError(error);
        })
    }

    saveProduct() {
        this.loading = true;

        // @todo hacky favorit håndtering
        const favoritStatus = this.product.variants.find((item) => {
            return item.variant_group_id === 2
        });
        if (this.favorite === true) {
            this.product.variants.push({variant_group_id: 2, id: 1281}); // @TODO get id's dynamically
        } else {
            if (favoritStatus) {
                this.product.variants.splice(this.product.variants.indexOf(favoritStatus), 1);
            }
        }

        forkJoin([
                this.http.patch(environment.apiBase + '/api/tenfour-crawler/price-adjustments/' + this.product.price_adjustment.id, this.product.price_adjustment,
                    {headers: this.priceRobotProductsApiService.httpHeaders}),
                this.shopProductsService.saveProduct(this.product),
            ]
        ).subscribe(
            data => {
                this.loadData();
                this.modal.close();
            }
        );
    }

    configureData(days: number) {
        const crawler_urls: any = [];
        let i = 0;


        this.product.crawler_urls = this.product.crawler_urls.map((url) => {
            if (this.product.prices.length > 0 && this.product.prices[0].price && url.crawler_logs && url.crawler_logs.length > 0 && url.crawler_logs[0].process_result[0].price) {

                const ourPrice = +this.product.prices[0].price;
                const ourShipping = +this.product.price_adjustment.shipping_cost;
                const resultPrice = +url.crawler_logs[0].process_result[0].price;
                const resultShipping = +url.crawler_logs[0].process_result[0].delivery;

                if (this.includeShipping) {
                    url.pct_div = ((1 - ((ourPrice + ourShipping) / (resultPrice + resultShipping))) * 100);
                    url.diff = ourPrice + ourShipping - resultPrice + resultShipping;
                } else {
                    url.pct_div = ((1 - (ourPrice / resultPrice)) * 100);
                    url.diff = ourPrice - resultPrice;
                }
            } else {
                url.pct_div = undefined;
                url.diff = undefined;
            }
            return url;
        });

        this.product.crawler_urls.forEach(function (url: any) {
            let loop = new Date(Date.now() - 3600000 - (86400000 * days - 1));
            const end = new Date(Date.now());
            const prices: number[] = [];
            let ii = 0;
            let previous = 0;
            let firstPrice = true;
            while (loop <= end) {
//                    tag den ældste valide log på en dag
                const log = url.crawler_logs.filter(function (log: any) {
                    const date = new Date(log.created);
                    const obj = log.process_result;
                    return !isNaN(parseInt(obj[0].price)) && (date.getDate() === loop.getDate() && date.getMonth() === loop.getMonth());
                }).sort((a, b) => {
                    return (b.created > a.created) ? 1 : -1
                });

                if (log.length !== 0) {

                    const obj = log[log.length - 1].process_result;
                    if (!isNaN(parseInt(obj[0].price))) {
                        previous = parseInt(obj[0].price);
                        prices[ii] = parseInt(obj[0].price);
                        // Fylder de tidligere ud når den første pris findes
                        if (firstPrice) {
                            firstPrice = false;
                            for (let j = ii; j >= 0; j--) {
                                prices[j] = previous;
                            }
                        }
                    } else {
                        prices[ii] = 0;
                    }
                } else {
                    prices[ii] = previous;
                }

                loop = new Date(loop.setDate(loop.getDate() + 1));
                ii++;
            }
            crawler_urls[i] = {data: prices, label: url.crawler_website.name}
            i++;
        });
        this.crawler_urls = crawler_urls;
        this.updateChart(days);
    }

    updateChart(days: number) {
        let loop = new Date(Date.now() - (86400000 * days));
        const end = new Date(Date.now());
        let i = 0;
        while (loop <= end) {
            this.labels[i] = (loop.getDate()) + '.' + (loop.getMonth() + 1);
            loop = new Date(loop.setDate(loop.getDate() + 1));
            i++;
        }

        this.lineChartData = {
            datasets: this.crawler_urls,
            labels: this.labels,
        };
    }

    hideAll() {
        this.configureData(30);
        this.crawler_urls.forEach(function (url: any) {
            url.hidden = true;
        })

        this.lineChartData = {
            datasets: this.crawler_urls,
            labels: this.labels
        };
    }

    openModal(content: any) {
        this.modal = this.modalService.open(content);
    }

    startAddUrl(content) {
        this.priceRobotUrl = new PriceRobotUrl();
        this.modal = this.modalService.open(content);
    }

    saveUrl() {

        this.priceRobotUrl.products = [{id: this.product.id}];

        if (this.priceRobotUrl.id) {
            this.priceRobotCompetitorService.editCrawlerUrl(this.priceRobotUrl.crawler_website_id, this.priceRobotUrl).subscribe((result) => {
                this.loadData();
                this.modal.close();
            })
        } else {

            this.priceRobotCompetitorService.addCrawlerUrl(this.priceRobotUrl.crawler_website_id, this.priceRobotUrl).subscribe((result) => {
                this.loadData();
                this.modal.close();
            })
        }
    }

    startEditUrl(content, url: PriceRobotUrl) {
        this.priceRobotUrl = url;
        this.modal = this.modalService.open(content);
    }

    openLargeModal(content: any) {
        this.modalService.open(content, {size: 'xl'});
    }

    crawl(crawlerUrl) {
        this.priceRobotCrawlerUrlService.enqueue(crawlerUrl.id).subscribe((response) => {
            this.priceRobotMessageService.setMessage('Enqueued with id', false);
        }, (error) => {
        })
    }

    deleteUrl(crawlerUrl: PriceRobotUrl) {
        if (confirm('Er du sikker på du vil slette denne url?')) {

            this.priceRobotCompetitorService.deleteCrawlerUrl(crawlerUrl.crawler_website_id, crawlerUrl).subscribe((response) => {
                this.loadData();

            }, (error) => {
            })
        }
    }

    changeSorting() {
        const costpriceTax = this.product?.price_adjustment?.costprice_2 * 1.25;
        this.product.price_adjustment.minimum_price = costpriceTax + (costpriceTax * (this.product?.price_adjustment?.minium_margin / 100));
        if (this.includeShipping) {
            this.product.price_adjustment.minimum_price = this.product.price_adjustment.minimum_price + this.product.price_adjustment.shipping_cost;
        }
        this.configureData(30);
    }

    rescan(force: boolean, crawler_website_id=null) {
        this.priceRobotProductsApiService.rescan(this.product.id, force, crawler_website_id).subscribe((response) => {
            this.loadData();
        })
    }
}
